// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__V9B9W","log":"ModalInventoryLogs_log__1pXH6","date":"ModalInventoryLogs_date__3bNqL","userName":"ModalInventoryLogs_userName__1xxCD"};